/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { DraggableDirective } from "app/directives/draggable.directive";
import { HHSeekAndFindOperation } from "app/models/hhseekandfind-operation-dto";
import { ObjectDefinition } from "app/models/object-definition";
import { Property } from "app/models/property";
import { TagDefinition } from "app/models/tag-definition";
import { Asset96RfidEncodingScheme_Uuid, Asset96Tag_Uuid, Grai96Tag_Uuid, GraiRfidEncodingScheme_Uuid, GtinRfidEncodingScheme_Uuid, Sgtin96Tag_Uuid } from "../page/hhseekandfind-page.component";

/** Add variable $ for bootstrap support. */
declare var $: any;

@Component({
    selector: 'ef-hhseekandfind-dialog',
    templateUrl: './hhseekandfind-dialog.component.html',
    styleUrls: ['./hhseekandfind-dialog.component.css']
  })
export class HHSeekAndFindDialogComponent {

  /** Draggable Directive added to that the popup is draggable.  Referenced so that the position can be reset. */
  @ViewChild(DraggableDirective) draggableDirective: DraggableDirective;

  op: HHSeekAndFindOperation = null;

  encodingSchemeTypes: ObjectDefinition[] = [];

  tagTypes: TagDefinition[] = [];

  allTagProperties: Property[] = [];

  /** Called when the "Confirm" button is clicked */
  @Output()
  confirmClicked = new EventEmitter<void>();

  /** Called when the "Cancel" button is clicked */
  @Output()
  cancelClicked = new EventEmitter<void>();

  /**
   * Constructor
   */
  constructor() { }

  /**
   * Called to show the Dialog.
   * 
   * This also resets the "Drag" position so that it appears in the same position
   * every time it is opened. 
   */
  public showDialog(newOp: HHSeekAndFindOperation, encodingTypes: ObjectDefinition[], tagTypes: TagDefinition[]): void {    
    this.op = newOp;
    this.encodingSchemeTypes = encodingTypes == null? [] : encodingTypes;
    this.tagTypes= tagTypes == null? [] : tagTypes;

    this.refreshTagProperties();

    if (this.op != null) {
      if (this.op?.encoding_type?.id) {
        this.op.encoding_type = this.encodingSchemeTypes.find(type => type?.id == this.op.encoding_type.id);
      }
      if (this.op?.main_property?.id) {
        this.op.main_property = this.op?.encoding_type?.properties?.find(property => property?.id == this.op.main_property.id);
      }
      this.draggableDirective.reset(); // Reset the Draggable Directive so that the Dialog pops up in the same place (Horizontally centered at the top of the screen)
      $("#hhseekandfind_Dialog").show();
    }
  }

  public getOp(): HHSeekAndFindOperation {
    return this.op;
  }

  /**
   * Called to hide the Dialog
   */
  public hideDialog(): void {
      $("#hhseekandfind_Dialog").hide();
  }





  refreshTagProperties(): void {
    console.log(`refreshTagProperties()`);

    const rv: Property[] = [];
    if (this.op?.encoding_type?.uuid?.length > 0) {
      let tagType: TagDefinition = null;
      console.log(`Searching for: '${this.op.encoding_type.uuid}'...`);
      switch (this.op.encoding_type.uuid) {
        case GtinRfidEncodingScheme_Uuid:
          tagType = this?.tagTypes?.find(type => type.uuid = Sgtin96Tag_Uuid);
          break;
        case GraiRfidEncodingScheme_Uuid:
          tagType = this?.tagTypes?.find(type => type.uuid = Grai96Tag_Uuid);
          break;
        case Asset96RfidEncodingScheme_Uuid:
          tagType = this?.tagTypes?.find(type => type.uuid = Asset96Tag_Uuid);
          break;
        default: 
          tagType = null;
          break;
      }
      if (tagType?.properties?.length > 0) {
        console.log(`Found Tag Type: ${JSON.stringify(tagType)}`);
        tagType.properties.sort((p1: Property, p2: Property) => p1.order - p2.order);
        rv.push(...tagType.properties);
      }
    }

    this.allTagProperties = rv;
    console.log(`New Tag Properties: ${JSON.stringify(this.allTagProperties)}`);
  }






  /**
   * Called when the Cancel button (or top left X) is clicked
   * Cancels the confirmation.
   */
  onCancelClicked(): void {
      this.cancelClicked.emit();
  }

  /**
   * Called when the Confirm button is clicked.
   * Confirms the action.
   */
  onConfirmClicked(): void {
      this.confirmClicked.emit();
  }



}